import { canUseNewTimelineForUnmigratedLiveEvent } from '@goldcast/player-config/src/utils/clipUtils';
import Button from '@/components/atoms/Button/Button';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';

const ClipCustomizerMigrateNudge = () => {
  const { clipData } = useClipsContext();
  if (!canUseNewTimelineForUnmigratedLiveEvent(clipData)) {
    return null;
  }

  return (
    <div className="mt-5 rounded-md border border-black border-opacity-10 bg-orange-50 px-3 py-2.5 text-sm">
      <div className="font-medium">Legacy project</div>
      <div className="mt-1 font-light">In order to use Speaker layouts, the project needs to be migrated.</div>
      <Button
        className="mt-2"
        variation="filled"
        trackingId="migrate-project-layout-nudge"
        onClick={() => {
          EventBus.dispatch(CustomEvents.OpenEventMigrationPopup, { source: 'ClipCustomizerMigrateNudge' });
        }}
      >
        Migrate project
      </Button>
    </div>
  );
};

export default ClipCustomizerMigrateNudge;
